import { render, staticRenderFns } from "./PriceText.vue?vue&type=template&id=597d4ba1&scoped=true&"
import script from "./PriceText.vue?vue&type=script&lang=js&"
export * from "./PriceText.vue?vue&type=script&lang=js&"
import style0 from "./PriceText.vue?vue&type=style&index=0&id=597d4ba1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597d4ba1",
  null
  
)

export default component.exports